module.exports = __webpack_public_path__ + "static/media/smile.c8e8b2a7.jpg";